export default __webpack_public_path__ + "assets/ico_contract_updates-aa5cc97c.svg";